"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _servicesCore = require("@makerdao/services-core");

var _bignumber = _interopRequireDefault(require("bignumber.js"));

var _constants = require("../utils/constants");

var _tracksTransactions = _interopRequireDefault(require("../utils/tracksTransactions"));

var _class;

var maxAllowance = (0, _bignumber["default"])(_constants.UINT256_MAX).shiftedBy(-18);
var AllowanceService = (_class =
/*#__PURE__*/
function (_PrivateService) {
  (0, _inherits2["default"])(AllowanceService, _PrivateService);

  function AllowanceService() {
    var _this;

    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'allowance';
    (0, _classCallCheck2["default"])(this, AllowanceService);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(AllowanceService).call(this, name, ['token', 'event']));
    _this._shouldMinimizeAllowance = false;
    return _this;
  }

  (0, _createClass2["default"])(AllowanceService, [{
    key: "initialize",
    value: function initialize(settings) {
      if (settings && settings.useMinimizeAllowancePolicy) {
        this._shouldMinimizeAllowance = true;
      }
    }
  }, {
    key: "requireAllowance",
    value: function () {
      var _requireAllowance = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee(tokenSymbol, receiverAddress, _ref) {
        var _ref$estimate, estimate, promise, token, ownerAddress, allowance, tx, _tx;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref$estimate = _ref.estimate, estimate = _ref$estimate === void 0 ? maxAllowance : _ref$estimate, promise = _ref.promise;
                token = this.get('token').getToken(tokenSymbol);
                ownerAddress = this.get('token').get('web3').currentAddress();
                _context.next = 5;
                return token.allowance(ownerAddress, receiverAddress);

              case 5:
                allowance = _context.sent;

                if (!(allowance.lt(maxAllowance.div(2)) && !this._shouldMinimizeAllowance)) {
                  _context.next = 12;
                  break;
                }

                _context.next = 9;
                return token.approveUnlimited(receiverAddress, {
                  promise: promise
                });

              case 9:
                tx = _context.sent;
                this.get('event').emit('allowance/APPROVE', {
                  transaction: tx
                });
                return _context.abrupt("return", tx);

              case 12:
                if (!(allowance.lt(estimate) && this._shouldMinimizeAllowance)) {
                  _context.next = 17;
                  break;
                }

                _context.next = 15;
                return token.approve(receiverAddress, estimate, {
                  promise: promise
                });

              case 15:
                _tx = _context.sent;
                this.get('event').emit('allowance/APPROVE', {
                  transaction: _tx
                });

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function requireAllowance(_x, _x2, _x3) {
        return _requireAllowance.apply(this, arguments);
      }

      return requireAllowance;
    }()
  }, {
    key: "removeAllowance",
    value: function () {
      var _removeAllowance = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2(tokenSymbol, spenderAddress, _ref2) {
        var promise, token, allowance;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                promise = _ref2.promise;
                token = this.get('token').getToken(tokenSymbol);
                _context2.next = 4;
                return token.allowance(this.get('token').get('web3').currentAddress(), spenderAddress);

              case 4:
                allowance = _context2.sent;

                if (!(parseInt(allowance) != 0)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", token.approve(spenderAddress, '0', {
                  promise: promise
                }));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function removeAllowance(_x4, _x5, _x6) {
        return _removeAllowance.apply(this, arguments);
      }

      return removeAllowance;
    }()
  }]);
  return AllowanceService;
}(_servicesCore.PrivateService), ((0, _applyDecoratedDescriptor2["default"])(_class.prototype, "requireAllowance", [_tracksTransactions["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "requireAllowance"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "removeAllowance", [_tracksTransactions["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "removeAllowance"), _class.prototype)), _class);
exports["default"] = AllowanceService;